import React from "react";

const CoreValues = () => {
  return (
    <>
      <div className="trapezoid-wrapper mrg-top">
        <div className="trapezoid"></div>
        <div className="inner-trapezoid"></div>
        <h2 className="inner-value poppins-bold">Core Values</h2>
        <h1 className="inner-bee">
          <span className="bee-space">B</span>
          <span className="bee-space">E</span>
          <span className="bee-space">E</span>
        </h1>
      </div>
      <div>
        <div className="row card-columns d-flex justify-content-center">
          <div className="core-value-wrapper core_val_sm" style={{ width: "14rem" }}>
            <div
              className="card col core-value-card"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body core-value-text">
                <p className="card-text">
                  Emphasize the connection between the mind and the body
                </p>
              </div>
            </div>
            <div className="rounded-circle core-value-circle flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="circle-text rajdhani-Light">H</div>
                </div>
                <div className="flip-card-back">
                  <div className="back-text-align">
                    <h1 className="flip-bee-opacity rajdhani-bold">BEE</h1>
                    <p>Holistic</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="core-value-wrapper core_val_sm" style={{ width: "14rem" }}>
            <div
              className="card col core-value-card"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body core-value-text">
                <p className="card-text">
                  Create and environment where the ideas can connect
                </p>
              </div>
            </div>
            <div className="rounded-circle core-value-circle flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="circle-text rajdhani-Light">I</div>
                </div>
                <div className="flip-card-back">
                  <div className="back-text-i">
                    <h1 className="flip-bee-opacity rajdhani-bold">BEE</h1>
                    <p>Innovative</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="core-value-wrapper core_val_sm" style={{ width: "14rem" }}>
            <div
              className="card col core-value-card"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body core-value-text">
                <p className="card-text">
                  To manage numerous functions with balance
                </p>
              </div>
            </div>
            <div className="rounded-circle core-value-circle flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="circle-text rajdhani-Light">V</div>
                </div>
                <div className="flip-card-back">
                  <div className="back-text-v">
                    <h1 className="flip-bee-opacity rajdhani-bold">BEE</h1>
                    <p>Versatile</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="core-value-wrapper core_val_sm" style={{ width: "14rem" }}>
            <div
              className="card col core-value-card"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body core-value-text">
                <p className="card-text">
                  Ethical practices to increase productivity and uphold
                  integrity
                </p>
              </div>
            </div>
            <div className="rounded-circle core-value-circle flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="circle-text rajdhani-Light">E</div>
                </div>
                <div className="flip-card-back">
                  <div className="back-text-e">
                    <h1 className="flip-bee-opacity rajdhani-bold">BEE</h1>
                    <p>Ethical</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="core-value-wrapper" style={{ width: "14rem" }}>
            <div
              className="card col core-value-card"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body core-value-text">
                <p className="card-text">
                  "A cooperative efforts" to accomplish the task with greater
                  efficiency
                </p>
              </div>
            </div>
            <div className="rounded-circle core-value-circle flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div className="circle-text rajdhani-Light">S</div>
                </div>
                <div className="flip-card-back">
                  <div className="back-text-s">
                    <h1 className="flip-bee-opacity rajdhani-bold">BEE</h1>
                    <p>Synergistic</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoreValues;
